import { useAppSelector } from "@hypexone/uicore";
import React from "react";

const NotFoundPage: React.FC = () => {
  const {langData} = useAppSelector((state) => state.cms);

  return (
    <div className="flex h-full items-center justify-center font-bold text-xl md:text-3xl">
      {langData?.['page_not_found']}
    </div>
  );
};

export default NotFoundPage;
